import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Thanh toán (Ezy). Mã nghiệp vụ, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'pay.later': 'Chưa mở ở bản này',
  'pay.tab.thu': 'Thu', 'pay.tab.chi': 'Chi', 'pay.tab.bt': 'Bù trừ',
  'pay.m.ok': 'Khớp đủ', 'pay.m.part': 'Một phần', 'pay.m.sug': 'Hana gợi ý', 'pay.m.none': 'Chưa khớp',
  'pay.s.rec': 'Ghi nhận', 'pay.s.match': 'Chờ duyệt', 'pay.s.appr': 'Đã duyệt', 'pay.s.post': 'Đã hạch toán', 'pay.s.rev': 'Đã đảo', 'pay.s.void': 'Đã huỷ',
  'pay.dt.all': 'Tất cả đối tượng', 'pay.dt.cus': 'khách', 'pay.dt.par': 'đối tác', 'pay.dt.agent': 'đại lý', 'pay.dt.inv': 'HĐ {v}',
  'pay.title': 'Thanh toán',
  'pay.period': 'Kỳ', 'pay.month': 'Tháng {n}',
  'pay.chip.un': 'Chưa khớp', 'pay.chip.unTip': 'Giao dịch chưa khớp với debit / hoá đơn / phiếu',
  'pay.chip.wait': 'Chờ duyệt', 'pay.chip.waitTip': 'Đã khớp, chờ người duyệt',
  'pay.chip.dead': 'Đã đảo / huỷ', 'pay.chip.deadTip': 'Có lý do · không xoá cứng',
  'pay.tool.import': 'Nhập sao kê ngân hàng', 'pay.tool.export': 'Xuất Excel', 'pay.tool.history': 'Lịch sử thay đổi',
  'pay.record': 'Ghi nhận',
  'pay.kind': 'Loại giao dịch', 'pay.searchLabel': 'Tìm giao dịch', 'pay.searchPh': 'Số phiếu, khách, job, nội dung CK',
  'pay.histLabel': 'Lịch sử theo đối tượng', 'pay.count': '{n} giao dịch', 'pay.total': '{k} {v} tr',
  'pay.ledger': 'Sổ giao dịch', 'pay.empty': 'Không có giao dịch.', 'pay.summary': 'Tóm tắt kỳ',
  'pay.col.method': 'Hình thức', 'pay.col.account': 'Tài khoản', 'pay.col.date': 'Ngày', 'pay.col.party': 'Đối tượng',
  'pay.col.amount': 'Số tiền · tr ₫', 'pay.col.doc': 'Chứng từ', 'pay.col.match': 'Khớp',
  'pay.col.alThu': 'Phân bổ vào debit / HĐ', 'pay.col.alChi': 'Phân bổ vào DBN / SOA / phiếu', 'pay.col.alBt': 'Phải thu ⇄ phải trả',
  'pay.by': 'Người ghi {u}', 'pay.byNoPhoto': 'Người ghi {u} · chưa có ảnh đại diện',
  'pay.view': 'Xem giao dịch {id}', 'pay.hasPhoto': 'Có ảnh chứng từ', 'pay.withPhoto': ' · có ảnh',
  'pay.allocTip': '{a} {b} · job {c} · lần này {v} tr', 'pay.unalloc': 'Chưa phân bổ',
  'pay.pillTip': 'Khớp: {m} · trạng thái: {s}',
});
addMessages('en', {
  'pay.later': 'Not available in this version',
  'pay.tab.thu': 'Receipts', 'pay.tab.chi': 'Payments', 'pay.tab.bt': 'Offset',
  'pay.m.ok': 'Fully matched', 'pay.m.part': 'Partial', 'pay.m.sug': 'Hana suggests', 'pay.m.none': 'Unmatched',
  'pay.s.rec': 'Recorded', 'pay.s.match': 'Pending approval', 'pay.s.appr': 'Approved', 'pay.s.post': 'Posted', 'pay.s.rev': 'Reversed', 'pay.s.void': 'Voided',
  'pay.dt.all': 'All parties', 'pay.dt.cus': 'customer', 'pay.dt.par': 'partner', 'pay.dt.agent': 'agent', 'pay.dt.inv': 'Contract {v}',
  'pay.title': 'Payments',
  'pay.period': 'Period', 'pay.month': 'Month {n}',
  'pay.chip.un': 'Unmatched', 'pay.chip.unTip': 'Transactions not matched to a debit / invoice / voucher',
  'pay.chip.wait': 'Pending approval', 'pay.chip.waitTip': 'Matched, awaiting approver',
  'pay.chip.dead': 'Reversed / voided', 'pay.chip.deadTip': 'With reason · never hard-deleted',
  'pay.tool.import': 'Import bank statement', 'pay.tool.export': 'Export Excel', 'pay.tool.history': 'Change history',
  'pay.record': 'Record',
  'pay.kind': 'Transaction type', 'pay.searchLabel': 'Search transactions', 'pay.searchPh': 'Voucher no., customer, job, transfer note',
  'pay.histLabel': 'History by party', 'pay.count': '{n} transactions', 'pay.total': '{k} {v} m',
  'pay.ledger': 'Transaction ledger', 'pay.empty': 'No transactions.', 'pay.summary': 'Period summary',
  'pay.col.method': 'Method', 'pay.col.account': 'Account', 'pay.col.date': 'Date', 'pay.col.party': 'Party',
  'pay.col.amount': 'Amount · m ₫', 'pay.col.doc': 'Document', 'pay.col.match': 'Match',
  'pay.col.alThu': 'Allocated to debit / invoice', 'pay.col.alChi': 'Allocated to DBN / SOA / voucher', 'pay.col.alBt': 'Receivable ⇄ payable',
  'pay.by': 'Recorded by {u}', 'pay.byNoPhoto': 'Recorded by {u} · no avatar',
  'pay.view': 'View transaction {id}', 'pay.hasPhoto': 'Has document image', 'pay.withPhoto': ' · has image',
  'pay.allocTip': '{a} {b} · job {c} · this time {v} m', 'pay.unalloc': 'Unallocated',
  'pay.pillTip': 'Match: {m} · status: {s}',
});
